<div #scrollTarget></div>
<div *ngIf="errorList && errorList.length" class="field-validation-error">
    <ul>
        <li *ngFor="let errMsg of errorList" [innerHTML]="errMsg"></li>
    </ul>
</div>